import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = { class: "d-flex w-100" }
const _hoisted_3 = { class: "flex-fill" }

import OAuthButton from "~/core-ui/vue/ui/oauth/OAuthButton.vue";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import {computed} from "vue";
import {AccountStore} from "~/cabinet/ts/store/AccountStore";
import {OAuthEventPayloadInterface} from "~/cabinet/vue/auth/Interface";



const __default__ = {
    name: "SocnetButtons"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    registrationForm: { type: Boolean }
  },
  emits: ["auth"],
  setup(__props: any, { emit: __emit }) {


let dealerParams = computed(() => AccountStore.data.value.dealerCabinetConfig);

let props = __props;

let emits = __emit;

let providers = computed(() => {
    let providers = dealerParams.value.oAuthProviders;
    if (props.registrationForm) {
        providers = providers.filter(provider => provider.isAvailableInRegForm);
    }
    return providers;
})


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_unref(providers).length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "d-flex text-muted align-items-center" }, [
          _createElementVNode("div", {
            class: "flex-fill",
            style: {"border-top":"1px solid #d5d5d5"}
          }),
          _createElementVNode("div", { class: "pr-2 pl-2" }, "или"),
          _createElementVNode("div", {
            class: "flex-fill",
            style: {"border-top":"1px solid #d5d5d5"}
          })
        ], -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(providers), (oAuthProvider) => {
          return (_openBlock(), _createElementBlock("div", {
            key: oAuthProvider.id,
            class: "mt-1"
          }, [
            _createVNode(OAuthButton, {
              "authorization-url": oAuthProvider.authorizationUrl,
              onAuth: ($event: any) => (_unref(emits)('auth', {oAuthProviderId: oAuthProvider.id, result: $event}))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  class: _normalizeClass({
                        'w-100 d-block oauth-button': true,
                        [oAuthProvider.id]: true
                    })
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(FontAwesomeIcon, {
                        icon: oAuthProvider.icon,
                        class: "mr-1"
                      }, null, 8, ["icon"]),
                      _createElementVNode("span", _hoisted_3, _toDisplayString(oAuthProvider.descr), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["class"])
              ]),
              _: 2
            }, 1032, ["authorization-url", "onAuth"])
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})